import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

const schema = z.object({
  description: z.string().trim().min(1).max(2000),
  captchaAnswer: z.number().int(),
  captchaExpected: z.number().int(),
  pageUrl: z.string().max(500).optional(),
  userAgent: z.string().max(500).optional(),
});

export const reportIssue = createServerFn({ method: "POST" })
  .inputValidator((data: unknown) => schema.parse(data))
  .handler(async ({ data }) => {
    if (data.captchaAnswer !== data.captchaExpected) {
      return { ok: false as const, error: "Incorrect captcha answer." };
    }

    const record = {
      receivedAt: new Date().toISOString(),
      description: data.description,
      pageUrl: data.pageUrl ?? null,
      userAgent: data.userAgent ?? null,
    };

    // Persist to server logs (visible via server-function-logs).
    // Swap for a DB write once Lovable Cloud is enabled.
    console.log("[report-issue]", JSON.stringify(record));

    return { ok: true as const };
  });